<div class="rating-consensus-wrapper">
  <div class="display-flex flex-align-center">
    <span class="sub-header">Rating Consensus</span>
    <va-icon 
    isFontAwesome="true"
    [name]="faInfoCircle"
    class="rating-consensus-icon"
    nz-popover
    nzPopoverTitle="Rating Consensus"
    [nzPopoverContent]="ratingConsToolTipTemplate"
    nzPopoverTrigger="click"
    nzPopoverPlacement="right"
    nzPopoverWidth="200px"
  ></va-icon>
  </div>
  <ng-template #ratingConsToolTipTemplate>
    <div style="width: 400px; color: #000000A6">
      The Rating Consensus value is calculated through the sum of all normalized
      scores in consensus, divided by the number of participants contributing to
      the consensus rating.
      <br />
      <br />
      The resulting score will fall within a range of 1-5, where a Buy, Hold, or
      Sell rating will be assigned.
      <br />
      <br />
      <a
        href="https://support.visiblealpha.com/hc/en-us/articles/16525196418068-Getting-Started-with-Insights-Target-Price-and-Ratings-for-the-Sell-Side#01H64DQD8TF34KVCSY2PMS890G"
        target="_blank"
      >
        Learn More
      </a>
    </div>
  </ng-template>

  <div class="rating-info">
    <div
      [ngClass]="
        data && data.you_rating
          ? 'consensus-info'
          : 'consensus-info-no-you-rating'
      "
    >
      <div
        class="out-of"
        *ngIf="ratingConsensusDataReady && !hasConsensus && !totalBroker"
      >
        - / - Brokers
      </div>
      <div
        class="out-of"
        *ngIf="
          ratingConsensusDataReady &&
          !hasConsensus &&
          totalBroker &&
          (!brokerInRatingConsensus || brokerInRatingConsensus < 3)
        "
      >
        - / {{ totalBroker }} Brokers
      </div>
      <div
        class="no-consensus-msg"
        *ngIf="ratingConsensusDataReady && !hasConsensus"
      >
        Too few ratings to calculate consensus.
      </div>

      <div *ngIf="hasConsensus">
        <div class="out-of">
          {{ brokerInRatingConsensus || "-" }} / {{ totalBroker }} Brokers
        </div>
        <div>
          <ul>
            <li class="bullet">
              <span
                *ngIf="data.rating_numeric && hasConsensus"
                class="content-bullet"
              >
                {{ data.rating }}: {{ data.rating_numeric.toFixed(2) }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="rating-you-info" *ngIf="data && data.you_rating">
      <div class="sub-header-seperator"></div>

      <div class="rating-you-values">
        <div class="out-of">{{ data.broker || "Sellside Rating" }}</div>

        <div>
          <ul>
            <li class="you-bullet">
              <span class="content-bullet">
                {{ data.normalized_rating }}: {{ data.you_rating.toFixed(2) }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="rating-consensus-chart">
    <highcharts-chart
      *ngIf="chartOptions"
      class="guage-chart"
      [Highcharts]="highcharts"
      [options]="chartOptions"
    ></highcharts-chart>
  </div>
</div>
